import React, { useState, useEffect, useCallback } from 'react'
import {
  Modal,
  Form,
  Button,
  OverlayTrigger,
  Tooltip,
  Row,
  Col,
} from 'react-bootstrap'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Navbar from '../../components/navbar/navbar.jsx'
import '../pedido-editar/pedido-editar.css'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import { CustomButton } from '../../components/CustomButton/index.jsx'
import api from '../../services/api.js'
import AutocompleteProdutoMatch from '../../components/auto-complete-match-produto/complete-match.jsx'
import AutocompleteClienteNode from '../../components/autocomplete-cliente/autocomplete-clientenode.jsx'
import apinode from '../../services/apinode.js'
import { set } from 'date-fns'
import { NumberFormat } from 'react-number-format'
import swal from 'sweetalert'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import clientesPDF from './report.jsx'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage.js'
import { toast } from 'react-toastify'
import { CheckCircleFill, ShareFill, XCircleFill } from 'react-bootstrap-icons'
import { CustomPriceInput } from '../../components/CustomPriceInput/index.jsx'
import { adaptValue } from '../../utils/adaptValue.js'
import { adaptToDatabase } from '../../utils/adaptToDatabase.js'
import OrcamentosService from '../../services/database/OrcamentosService/index.js'
import ModalIncluirCliente from './ModalIncluirCliente.jsx'
import { useCommand } from '../../hooks/useCommand/index.js'
import reportOrcNoWMS from './reportOrcNoWMS.jsx'

function OrcamentoEditar() {
  const { id_pedido } = useParams()
  const [clienteSemCada, setSemCad] = useState('')

  const { conta, print } = useParams()
  const [textoDigitado, setTextoDigitado] = useState('')
  const [estaBuscando, setEstaBuscando] = useState(true)

  const [dt_pedido, setDtPedido] = useState('')
  const [id_cond_pagto, setIdCondPagto] = useState(0)
  const [dt_entrega, setDtEntrega] = useState('')
  const [obs, setObs] = useState('')
  const [produtos, setProdutos] = useState([])
  const [vl_total, setVlTotal] = useState(0)
  const [msg, setMsg] = useState('')
  const [desconto, setDesconto] = useState(0)
  const [vendedor, setVendedor] = useState('')
  const [prestador, setPrestador] = useState('')
  const [indicacaoVenda, setIndicacaoVenda] = useState('')
  const [lista_produtos, setListaProdutos] = useState([])
  const [lista_clientes, setListaClientes] = useState([])
  const [cond_pagtos, setCondPagtos] = useState([])
  const [produtoBanco, setProdutoBanco] = useState('')
  const [matchResultado, setMatchResultado] = useState(null)
  const [matchproduto, setMatchProduto] = useState('')
  const [codinterno, setCodigoInterno] = useState('')
  const [id_cliente, setIdCliente] = useState('')
  const [nomeCliente, setNomeCliente] = useState('')
  const [cliente, setCliente] = useState('')
  const [cpf, setCpf] = useState('')
  const [dadospedido, setDadosPedido] = useState({})
  const [vendedores, setVendedores] = useState([])
  const [parceiros, setParceiros] = useState([])
  const [prestadores, setPrestadores] = useState([])
  const [parceiro, setParceiro] = useState('')
  const [detalhesPedido, setDetalhesPedido] = useState('')
  const [descontoItem, setDescontoItem] = useState([])
  const [dadosEmp, setDadosEmp] = useState([])
  const [totalCusto, setTotalCusto] = useState(0)
  const [loading, setLoading] = useState(false)
  const [grupoItem, setGrupoItem] = useState('')
  const [itemSelecionado, setItemSelecionado] = useState(null)
  const [inputValue, setInputValue] = useState('')
  const [inputSeq, setInputSeqValue] = useState('')
  const [nomeParceiro, setNomeParceiro] = useState(null)

  const [clientes, setClientes] = useState([])
  const [isDeleteProductLoading, setIsDeleteProductLoading] = useState({})
  const [isExportSaleLoading, setIsExportSaleLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [gruposVisiveis, setGruposVisiveis] = useState({})

  const navigate = useNavigate()

  const handleOpenModal = () => {
    setShowModal(true)
  }

  const agrupados = produtos.reduce((acc, produto) => {
    const grupo = produto.grupo_item?.trim().toUpperCase() || 'OUTRO'

    if (!acc[grupo]) {
      acc[grupo] = []
    }

    acc[grupo].push(produto)
    return acc
  }, {})

  const handleSaveCliente = ({ cpf, nome }) => {
    setCpf(cpf)
    setNomeCliente(nome)
    setSemCad(true) // Indicate that the client is not registered
    setShowModal(false) // Close the modal after saving
  }

  // Convertendo o objeto de grupos em um array
  const produtosAgrupados = Object.entries(agrupados).map(
    ([grupo, produtos]) => ({
      grupo,
      produtos,
    }),
  )

  const handleInserir = () => {
    if (itemSelecionado !== null && inputValue.trim() !== '') {
      const novosProdutos = [...produtos]
      novosProdutos[itemSelecionado] = {
        ...novosProdutos[itemSelecionado],
        grupo_item: inputValue?.toUpperCase(),
      }

      // Agrupa os produtos pelo campo grupo_item
      const produtosAgrupados = novosProdutos.reduce((acc, produto) => {
        const grupo = produto.grupo_item
        if (!acc[grupo]) {
          acc[grupo] = []
        }
        acc[grupo].push(produto)
        return acc
      }, {})

      // Converte o objeto agrupado de volta para um array
      const produtosAgrupadosArray = Object.values(produtosAgrupados).flat()

      // Atualiza o estado de produtos com o array agrupado
      setProdutos(produtosAgrupadosArray)

      setItemSelecionado(null) // Fecha o modal após a inserção
      setInputValue('') // Limpa o valor do input
      setInputSeqValue('') // Limpa o valor do input
    }
  }

  const handleInputChange = (e) => {
    setInputValue(e.target.value)
    if (itemSelecionado !== null) {
      const novosProdutos = [...produtos]
      novosProdutos[itemSelecionado] = {
        ...novosProdutos[itemSelecionado],
        grupo_item: e.target.value?.toUpperCase(), // Atualiza grupo_item
      }
      setProdutos(novosProdutos)
    }
  }

  const handleSeqChange = (e) => {
    setInputSeqValue(e.target.value)
    if (itemSelecionado !== null) {
      const novosProdutos = [...produtos]
      novosProdutos[itemSelecionado] = {
        ...novosProdutos[itemSelecionado],
        seq_item: e.target.value?.toUpperCase(), // Atualiza seq_item
      }
      setProdutos(novosProdutos)
    }
  }

  // Calcula o total_custo somando o total_custo de cada produto
  const calcularTotalCusto = () => {
    return produtos.reduce(
      (total, produto) => total + (produto.total_custo || 0),
      0,
    )
  }

  const moverProdutoParaCima = (index) => {
    if (index === 0) return

    setProdutos((prevProdutos) => {
      const novosProdutos = [...prevProdutos]
      const produtoSelecionado = novosProdutos[index]
      const produtoAnterior = novosProdutos[index - 1]
      novosProdutos[index - 1] = produtoSelecionado
      novosProdutos[index] = produtoAnterior
      return novosProdutos
    })
  }

  const moverProdutoParaBaixo = (index) => {
    if (index === produtos.length - 1) return

    setProdutos((prevProdutos) => {
      const novosProdutos = [...prevProdutos]
      const produtoSelecionado = novosProdutos[index]
      const proximoProduto = novosProdutos[index + 1]
      novosProdutos[index + 1] = produtoSelecionado
      novosProdutos[index] = proximoProduto
      return novosProdutos
    })
  }

  async function handleExportSale(idOrcamento) {
    if (produtos.length === 0) {
      return toast.warn('É necessário ao menos ter 1 produto!')
    }

    try {
      setIsExportSaleLoading(true)

      const dataMessage = await OrcamentosService.exportToSales(idOrcamento)

      toast.success(dataMessage)
      navigate('/orcamentos')
    } catch (err) {
      sendErrorApiMessage(err, 'Houve um erro ao exportar a venda!')
    } finally {
      setIsExportSaleLoading(false)
    }
  }

  /*   async function ImpPdf(tipo) {
    const dados_pedido = {
      numeroorc: id_pedido,
      cliente: nomeCliente,
      id_cliente: id_cliente || 0,
      id_pagamento: null,
      cod_vendedor: vendedor || null,
      data: dt_pedido || moment().format('YYYY-MM-DD'),
      valor: vl_total,
      desconto: descontoItem || null,
      desconto_din: desconto || 0,
      id_parceiro: indicacaoVenda || null,
      cpf: cpf,
      cod_vendedor: vendedor || null,
      detalhes_pedido: detalhesPedido || 'Não informado',
      itens: produtos,
      empresa: dadosEmp,
      dadosDoCliente: clientes,
    }

    // Função para converter uma imagem para Base64
    async function getBase64ImageFromUrl(url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.setAttribute('crossOrigin', 'anonymous')
        img.onload = function () {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0)
          const dataURL = canvas.toDataURL('image/jpeg')
          resolve(dataURL)
        }
        img.onerror = function (error) {
          reject(error)
        }
        img.src = url
      })
    }

    // Iterando sobre os itens para converter a imagem em Base64
    for (let i = 0; i < dados_pedido.itens.length; i++) {
      const item = dados_pedido.itens[i]
      try {
        // Verificando se o item tem uma imagem, caso contrário, usar uma imagem padrão
        const imageUrl = item.image
          ? `https://node.ziphub.com.br/imagens/${item.image}`
          : 'https://node.ziphub.com.br/imagens/no-image.jpg'

        // Convertendo a imagem para Base64 e adicionando como uma nova propriedade
        item.base64 = await getBase64ImageFromUrl(imageUrl)
      } catch (error) {
        console.error('Erro ao converter imagem para Base64:', error)
      }
    }

    // Chamando a função para gerar o PDF
    clientesPDF(dados_pedido, tipo);
  } */

  async function ImpPdf(tipo) {
    const selectElement = document.getElementById('parceiroSelect') // Obtém o elemento select pelo ID
    const selectedOption = selectElement
      ? selectElement.selectedOptions[0]
      : null // Obtém a opção selecionada
    const parceiroNome = selectedOption ? selectedOption.text : '' // Pega o texto da opção (PES_RAZAO)
    console.log(parceiroNome)

    const dados_pedido = {
      numeroorc: id_pedido,
      cliente: nomeCliente,
      id_cliente: id_cliente || 0,
      id_pagamento: null,
      cod_vendedor: vendedor || null,
      data: dt_pedido || moment().format('YYYY-MM-DD'),
      valor: vl_total,
      desconto: descontoItem || null,
      desconto_din: desconto || 0,
      id_parceiro: indicacaoVenda || null,
      cpf: cpf,
      cod_vendedor: vendedor || null,
      detalhes_pedido: detalhesPedido || 'Não informado',
      itens: produtos,
      empresa: dadosEmp,
      dadosDoCliente: clientes,
      Parceiro: parceiroNome,
    }

    // Função para converter uma imagem para Base64
    async function getBase64ImageFromUrl(url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.setAttribute('crossOrigin', 'anonymous')
        img.onload = function () {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0)
          const dataURL = canvas.toDataURL('image/jpeg')
          resolve(dataURL)
        }
        img.onerror = function (error) {
          reject(error)
        }
        img.src = url
      })
    }

    // Iterando sobre os itens para converter a imagem em Base64
    for (let i = 0; i < dados_pedido.itens.length; i++) {
      const item = dados_pedido.itens[i]
      try {
        // Verificando se o item tem uma imagem, caso contrário, usar uma imagem padrão
        const imageUrl = item.image
          ? item.image.includes('node.ziphub.com.br')
            ? item.image
            : `https://node.ziphub.com.br/imagens/${item.image}`
          : 'https://node.ziphub.com.br/imagens/no-image.jpg';

        // Convertendo a imagem para Base64 e adicionando como uma nova propriedade
        item.base64 = await getBase64ImageFromUrl(imageUrl)
      } catch (error) {
        console.error('Erro ao converter imagem para Base64:', error)

        try {
          // Tentativa de usar a imagem padrão caso ocorra um erro na conversão
          item.base64 = await getBase64ImageFromUrl(
            'https://node.ziphub.com.br/imagens/no-image.jpg',
          )
        } catch (error) {
          console.error('Erro ao converter a imagem padrão para Base64:', error)
          // Pode-se definir uma string base64 padrão aqui ou deixar em branco
          item.base64 = '' // ou qualquer base64 padrão que você queira usar
        }
      }
    }

    reportOrcNoWMS(dados_pedido, tipo)

    // localStorage.usa_wms === 'S'
    //   ? clientesPDF(dados_pedido, tipo)
    //   : reportOrcNoWMS(dados_pedido, tipo)
  }

  const reqToken = async (conta) => {
    try {
      const response = await api.get('/emp', {
        params: {
          token: conta,
        },
      })

      if (response.status === 200) {
        const token = response.data?.ID_CONTA

        if (!token) {
          // Sessão expirada ou token não encontrado
          swal(
            'Sessão expirada',
            'Por favor, feche e abra novamente.',
            'warning',
          )
        } else {
          // Atribuição para o state ou local storage (se necessário)
          setDadosEmp([response.data]) // Define o state "dadosEmp" com os dados recebidos
          localStorage.setItem('id_conta', token) // Define o "id_conta" no local storage
        }
      } else {
        console.log('Erro ao requisitar token. Status: ' + response.status)
      }
    } catch (error) {
      console.error('Erro na requisição:', error)
      // Tratamento de erro adicional, se necessário
      // Por exemplo, exibir uma mensagem de erro para o usuário
      swal('Erro na requisição', 'Ocorreu um erro ao buscar o token.', 'error')
    }
  }

  const handleDescontoTotal = (value) => {
    const descontoTotal = adaptValue(value)

    if (isNaN(descontoTotal) || descontoTotal <= 0) {
      // Se o valor do desconto não é um número válido ou é menor ou igual a zero, não aplicamos desconto
      setDesconto(null) // Resetar o desconto para zero

      setProdutos((prevState) =>
        prevState.map((produto) => ({
          ...produto,
          desconto: 0,
          valor_total_item: produto?.quantidade * produto.valorunitario,
        })),
      )

      return
    }

    // Calcula o valor total da compra
    const vl_total = produtos.reduce(
      (acc, produto) => acc + (produto.valor_total_item || 0),
      0,
    )

    // Calcula a proporção de desconto que cada item deve receber
    const proporcaoDesconto = descontoTotal / vl_total

    const updatedProdutos = produtos.map((produto) => {
      const quantidade = produto?.quantidade
      const valorUnitario = produto.valorunitario

      if (!isNaN(quantidade) && !isNaN(valorUnitario)) {
        // Calcula o desconto proporcional para o item atual
        const valorDesconto =
          proporcaoDesconto * (produto.valor_total_item || 0)

        // Calcula o valor total do item com desconto
        const valorTotalItem = quantidade * valorUnitario - valorDesconto

        return {
          ...produto,
          desconto: valorDesconto,
          valor_total_item: parseFloat(valorTotalItem), // Atualiza o valor total do item com desconto
        }
      }

      return produto
    })

    setDesconto(descontoTotal)
    setProdutos(updatedProdutos)
  }

  const handleIdCliente = (id) => {
    setIdCliente(id)
  }

  const handleCpf = (cpf) => {
    setCpf(cpf)
  }

  const handleDescontoChange = (value, index) => {
    const updatedProdutos = [...produtos]
    const produto = updatedProdutos[index]

    const quantidade = produto?.quantidade
    const valorUnitario = produto.valorunitario
    const desconto = value

    if (!isNaN(quantidade) && !isNaN(valorUnitario) && !isNaN(desconto)) {
      produto.valor_total_item = quantidade * valorUnitario - desconto
      produto.desconto = value
    } else {
      produto.valor_total_item = 0
    }

    setProdutos(updatedProdutos)
  }

  const parseDecimalValue = (value) => {
    const sanitizedValue = value.replace(',', '.')
    const parsedValue = parseFloat(sanitizedValue)
    return isNaN(parsedValue) ? '' : parsedValue.toFixed(2)
  }

  const alternarModoBusca = () => {
    setEstaBuscando((estadoAnterior) => !estadoAnterior)
  }

  const formatValue = (value) => {
    if (value == null) {
      return '' // Return an empty string or any default value for null or undefined values
    }
    return value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
  }

  const handleNomeCliente = (nome) => {
    setNomeCliente(nome)
    setDadosPedido((prevState) => ({
      ...prevState,
      cliente: nome,
    }))
  }

  const handleObsChange = (value, index) => {
    const updatedProdutos = [...produtos] // Create a copy of the produtos array
    updatedProdutos[index].obs = value // Update the obs value of the corresponding product
    setProdutos(updatedProdutos) // Update the state with the modified array
  }

  function handleProdutoIdChange(id, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].codigo = id
    setProdutos(updatedProdutos)
  }

  function handleProdutoNomeChange(nome, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].descricao = nome
    // updatedProdutos[index].codigo = '999999';
    setProdutos(updatedProdutos)
  }

  function handleProdutoNomeChangeInput(nome, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].descricao = nome
    updatedProdutos[index].codigo = '999999'

    setProdutos(updatedProdutos)
  }

  function handleProdutoInternoChange(prodInterno, index) {
    // const updatedProdutos = [...produtos]
    // updatedProdutos[index].id = prodInterno
    // setProdutos(updatedProdutos)
  }

  function AdicionarProduto() {
    const prod = {
      id: uuidv4(),
      codigo: 0,
      descricao: '',
      quantidade: '1',
      quantidade_nova: 1,
      valorunitario: 0,
      valor_total_item: 0,
      desconto: 0,
      preco_custo: 0,
      image: 'no-image.jpg',
      new: true,
    }

    setProdutos([...produtos, prod])
  }

  async function ExcluirProduto(produto, index) {
    if (produto.new) {
      setProdutos((prevState) => prevState.filter((p, i) => i !== index))
    } else {
      try {
        setIsDeleteProductLoading((prevState) => ({
          ...prevState,
          [index]: true,
        }))

        await apinode.delete(
          `/orcamentos/products/${produto.id}/${id_pedido}/${localStorage.idconta}`,
        )

        toast.success('Produto deletado com sucesso!')
        buscapedido(id_pedido)
      } catch (err) {
        sendErrorApiMessage(err, 'Não foi possível excluir o produto!')
      } finally {
        setIsDeleteProductLoading((prevState) => ({
          ...prevState,
          [index]: false,
        }))
      }
    }
  }

  const buscapedido = useCallback(
    async (idpedido, willLoad = true) => {
      willLoad && setLoading(true)

      try {
        const response = await apinode.get(
          `/getorcamentos/${idpedido}/${conta}`,
        )

        setProdutos(
          response.data.itens.map((item) => ({
            ...item,
            new: false,
          })),
        )

        setDadosPedido(response.data)
        setClientes(response.data.clientes[0])

        const {
          cliente,
          data,
          cod_vendedor,
          id_parceiro,
          id_prestador,
          cpf,
          id_cliente,
          desconto_din,
          detalhes_pedido,
        } = response.data

        const formattedDate = moment(data).format('YYYY-MM-DD')

        setDtPedido(formattedDate)
        setNomeCliente(cliente)
        setVendedor(cod_vendedor)
        setIndicacaoVenda(id_parceiro)
        setParceiro(id_parceiro)
        setPrestador(id_prestador)
        setIdCliente(id_cliente)
        setCpf(cpf)
        setDetalhesPedido(detalhes_pedido)
        setDesconto(parseFloat(desconto_din))
        setLoading(false)
      } catch (err) {
        console.error(err)
        willLoad && setLoading(false)
      }
    },
    [conta],
  )

  function formatDate(dateString) {
    if (!dateString) return '' // Handle empty or undefined dateString

    const date = new Date(dateString)

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
  }

  const CarregarDadosPedido = useCallback(
    (id_ped) => {
      if (id_ped > 0) {
        // setIdCliente(dadospedido?.id_cliente ?? 0);
        // setNomeCliente(dadospedido?.cliente);
        // setCpf(dadospedido?.cpf)

        const formattedDate = moment(dadospedido?.data).format('YYYY-MM-DD')

        // setDtPedido(formattedDate)

        setVendedor(dadospedido?.cod_vendedor)
        setParceiro(dadospedido?.id_parceiro)

        setIdCondPagto(2)
        setDtEntrega(moment().format('YYYY-MM-DD'))
        // setObs("Teste");
        // setDesconto(dadospedido?.desconto_din);
        setDetalhesPedido(dadospedido?.detalhes_pedido)
      } else {
        setIdCliente(0)
        setDtPedido(moment().format('YYYY-MM-DD'))
        setIdCondPagto(0)
        setDtEntrega(moment().format('YYYY-MM-DD'))
        setObs('')
        setDesconto(0)
        setVendedor('')
        setIndicacaoVenda('')
        setProdutos([])
      }
    },
    [dadospedido],
  )

  function PesquisarClientes() {
    setListaClientes([])
  }

  function PesquisarProdutos() {
    setListaProdutos([
      { id_item: 1, id_produto: 1, descricao: 'MONITOR DELL' },
      { id_item: 2, id_produto: 2, descricao: 'HD SEAGATE 2TB' },
      { id_item: 3, id_produto: 3, descricao: 'MOUSE LOGITECH' },
    ])
  }

  function PesquisarCondPagtos() {
    setCondPagtos([
      { id_cond_pagto: 1, cond_pagto: '30 Dias' },
      { id_cond_pagto: 2, cond_pagto: '45 Dias' },
    ])
  }

  function handleDescricaoChange(value, index) {
    setProdutos((prevProdutos) => {
      const newProdutos = [...prevProdutos]
      newProdutos[index].descricao = value
      return newProdutos
    })
  }

  function handleImg(value, index) {
    setProdutos((prevProdutos) => {
      const newProdutos = [...prevProdutos]
      newProdutos[index].image = value || 'no-image.jpg'
      return newProdutos
    })
  }

  function handleQtdChange(qtd, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].quantidade = qtd
    updatedProdutos[index].valor_total_item =
      qtd * updatedProdutos[index].valorunitario

    // Calcula o novo preço de custo
    updatedProdutos[index].total_custo =
      qtd * updatedProdutos[index].preco_custo

    setProdutos(updatedProdutos)
  }

  function handleVlUnitChange(vl, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].valorunitario = vl
    updatedProdutos[index].valor_total_item =
      updatedProdutos[index].quantidade * vl

    if (
      typeof updatedProdutos[index].valor_total_item === 'number' &&
      !isNaN(updatedProdutos[index].valor_total_item)
    ) {
      updatedProdutos[index].valor_novo =
        updatedProdutos[index].valor_total_item
    } else {
      // Se o valor não for um número válido, trate o erro aqui.
      // Por exemplo, você pode definir como 0 ou exibir uma mensagem de erro.
      updatedProdutos[index].valor_novo = 0
      console.error('Erro: valor_total_item não é um número válido.')
    }

    setProdutos(updatedProdutos)
  }

  function handleCusto(vl, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].preco_custo = vl || 0 // Converte o valor para número

    // Verifica se o valor é um número válido
    if (!isNaN(updatedProdutos[index].preco_custo)) {
      updatedProdutos[index].total_custo =
        updatedProdutos[index].quantidade * updatedProdutos[index].preco_custo
    } else {
      // Se o valor não for um número válido, trate o erro aqui.
      // Por exemplo, você pode definir como 0 ou exibir uma mensagem de erro.
      updatedProdutos[index].total_custo = 0
      console.error('Erro: preco_custo não é um número válido.')
    }

    setProdutos(updatedProdutos)
  }
  function CalculaTotal() {
    let total = 0
    produtos.forEach((prod) => {
      total += prod.valor_total_item
    })
    setVlTotal(total)
  }

  async function SalvarDados() {
    if (!nomeCliente) {
      swal('Erro', 'O campo cliente é obrigatório.', 'warning')
      return
    }

    if (
      produtos.length === 0 ||
      produtos.some((produto) => produto.descricao.trim() === '')
    ) {
      // Exiba uma mensagem de erro usando sweetAlert.
      swal(
        'Erro',
        'É necessário adicionar pelo menos um produto com a descrição preenchida.',
        'warning',
      )
      return // Aborta o processo de salvamento.
    }

    const produtosFormatted = produtos.map((produto) =>
      adaptToDatabase(produto, ['quantidade']),
    )

    const dados_pedido = {
      cliente: nomeCliente,
      id_cliente: id_cliente || 0,
      id_pagamento: null,
      cod_vendedor: vendedor || null,
      data: dt_pedido || moment().format('YYYY-MM-DD'),
      valor: vl_total,
      desconto: desconto || null,
      desconto_din: desconto || 0,
      id_parceiro: indicacaoVenda || null,
      id_prestador: prestador || null,
      cpf: cpf,
      cod_vendedor: vendedor || null,
      detalhes_pedido: detalhesPedido || 'Não informado',
      grupo_item: grupoItem || null,
      itens: produtosFormatted,
    }

    try {
      setLoading(true)

      const response = await apinode.put(
        `/vendedores/updateorc/${conta}/${id_pedido}`,
        dados_pedido,
      )

      swal('Sucesso', response.data.message, 'success')
      buscapedido(id_pedido)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível salvar o orçamento!')
    } finally {
      setLoading(false)
    }
  }

  const handleTextoChange = (texto) => {
    setTextoDigitado('texto' + texto)
  }

  function pressF2() {
    setEstaBuscando((prevState) => !prevState)
  }

  useCommand(pressF2, ['F2'])

  useEffect(() => {
    setTotalCusto(calcularTotalCusto())
  }, [produtos])

  useEffect(() => {
    reqToken(conta)
    localStorage.setItem('id_conta', conta)
    PesquisarClientes()
    PesquisarProdutos()
    PesquisarCondPagtos()

    buscapedido(id_pedido)
    // CarregarDadosPedido(id_pedido)
  }, [buscapedido, conta, id_pedido])

  useEffect(() => {
    const prepararParaImpressao = async () => {
      await CalculaTotal() // Aguarda a conclusão de CalculaTotal()

      if (print === 'print') {
        ImpPdf('Completo')
      }
    }

    prepararParaImpressao() // Chama a função assíncrona
  }, [produtos])

  useEffect(() => {
    // const conta = '514066249'

    apinode
      .get(`vendedores/prestador?conta=${conta}`)
      .then((response) => {
        setPrestadores(response.data)
      })
      .catch((error) => {
        console.error(error)
      })

    // Fazer a requisição para obter os vendedores
    apinode
      .get(`vendedores/vendedor?conta=${conta}`)
      .then((response) => {
        setVendedores(response.data)
      })
      .catch((error) => {
        console.error(error)
      })

    apinode
      .get(`vendedores/parceiros?conta=${conta}`)
      .then((response) => {
        setParceiros(response.data)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [])

  if (parceiros.length > 0) {
    parceiros.sort((a, b) => {
      const nomeA = a.PES_RAZAO.toLowerCase()
      const nomeB = b.PES_RAZAO.toLowerCase()
      if (nomeA < nomeB) {
        return -1
      }
      if (nomeA > nomeB) {
        return 1
      }
      return 0
    })
  }

  // Função para mover o grupo para cima
  const moverGrupoParaCima = (grupo) => {
    const grupoIndex = produtos.findIndex(
      (produto) =>
        produto.grupo_item?.trim().toUpperCase() ===
        grupo?.trim().toUpperCase(),
    )

    if (grupoIndex > 0) {
      const grupoAtual = produtos.filter(
        (produto) =>
          produto.grupo_item?.trim().toUpperCase() ===
          grupo?.trim().toUpperCase(),
      )

      const grupoAnterior = produtos.filter(
        (produto) =>
          produto.grupo_item?.trim().toUpperCase() ===
          produtos[grupoIndex - 1]?.grupo_item?.trim().toUpperCase(),
      )

      // Remove ambos os grupos da lista original
      let novaLista = produtos.filter(
        (produto) =>
          produto.grupo_item?.trim().toUpperCase() !==
          grupo?.trim().toUpperCase() &&
          produto.grupo_item?.trim().toUpperCase() !==
          produtos[grupoIndex - 1]?.grupo_item?.trim().toUpperCase(),
      )

      // Insere o grupo atual antes do grupo anterior
      novaLista.splice(
        grupoIndex - grupoAnterior.length,
        0,
        ...grupoAtual,
        ...grupoAnterior,
      )

      setProdutos(novaLista)
    }
  }

  // Função para mover o grupo para baixo
  const moverGrupoParaBaixo = (grupo) => {
    const grupoIndex = produtos.findIndex(
      (produto) =>
        produto.grupo_item?.trim().toUpperCase() ===
        grupo?.trim().toUpperCase(),
    )

    if (grupoIndex < produtos.length - 1) {
      const grupoAtual = produtos.filter(
        (produto) =>
          produto.grupo_item?.trim().toUpperCase() ===
          grupo?.trim().toUpperCase(),
      )

      const grupoProximo = produtos.filter(
        (produto) =>
          produto.grupo_item?.trim().toUpperCase() ===
          produtos[grupoIndex + grupoAtual.length]?.grupo_item
            ?.trim()
            .toUpperCase(),
      )

      // Remove ambos os grupos da lista original
      let novaLista = produtos.filter(
        (produto) =>
          produto.grupo_item?.trim().toUpperCase() !==
          grupo?.trim().toUpperCase() &&
          produto.grupo_item?.trim().toUpperCase() !==
          produtos[grupoIndex + grupoAtual.length]?.grupo_item
            ?.trim()
            .toUpperCase(),
      )

      // Insere o grupo atual depois do grupo próximo
      novaLista.splice(
        grupoIndex + grupoProximo.length,
        0,
        ...grupoProximo,
        ...grupoAtual,
      )

      setProdutos(novaLista)
    }
  }

  return (
    <>
      <Navbar />

      <div className="container-fluid mt-page form-pedido-editar">
        <div className="row col-lg-12 offset-lg-12">
          <div className="col-12 mb-4 mt-2">
            <h2 className="d-inline">
              {id_pedido > 0
                ? `Editar orçamento ${id_pedido}`
                : 'Novo Orçamento'}
            </h2>
          </div>
          <div className="col-md-6 mb-4">
            <label
              htmlFor="InputNome"
              className="form-label"
            >
              Cliente
            </label>
            <div className="d-flex align-items-center">
              <AutocompleteClienteNode
                placeholder="Pesquisar cliente...."
                onClickNome={handleNomeCliente}
                onClickId={handleIdCliente}
                onClickCpf={handleCpf}
                value={nomeCliente}
                className="form-control me-2" // Adiciona margem à direita
              />
              <button
                className="btn btn-primary d-flex align-items-center"
                onClick={handleOpenModal}
              >
                <i className="bi bi-plus"></i>
              </button>
            </div>
          </div>

          <div className="col-md-3 mb-4">
            <label
              htmlFor="InputEmail"
              className="form-label"
            >
              Data orçamento
            </label>
            <input
              type="date"
              onChange={(e) => {
                const newDate = e.target.value
                setDtPedido(newDate)
              }}
              value={dt_pedido}
              className="form-control"
              id="InputEmail"
              aria-describedby="email"
            />
          </div>

          <Row>
            <Col>
              <label
                htmlFor="InputNome"
                className="form-label"
              >
                Vendedor
              </label>
              <select
                onChange={(e) => setVendedor(e.target.value)}
                value={vendedor}
                className="form-control"
                id="InputNome"
                style={{ border: '1px solid #ced4da' }} // Estilo personalizado para o contorno
              >
                <option value="">Selecione um vendedor</option>
                {vendedores.map((vendedor) => (
                  <option
                    key={vendedor.COD_PESSOA}
                    value={vendedor.COD_PESSOA}
                  >
                    {vendedor.PES_RAZAO}
                  </option>
                ))}
              </select>
            </Col>

            <Col>
              <label
                htmlFor="InputNome"
                className="form-label"
              >
                Indicação de Venda
              </label>
              <select
                id="parceiroSelect"
                className="form-control"
                value={indicacaoVenda}
                onChange={(e) => {
                  const selectedCod = e.target.value // Obtém o valor selecionado (COD_PESSOA)
                  setIndicacaoVenda(selectedCod) // Atualiza o estado do indicador de venda

                  // Pega o nome diretamente a partir do texto do option selecionado
                }}
                style={{ border: '1px solid #ced4da' }}
              >
                <option value="">Selecione um parceiro</option>
                {parceiros.map((parceiro) => (
                  <option
                    key={parceiro.COD_PESSOA}
                    value={parceiro.COD_PESSOA}
                  >
                    {parceiro.PES_RAZAO}
                  </option>
                ))}
              </select>
            </Col>

            <Col>
              <label
                htmlFor="InputNome"
                className="form-label"
              >
                Prestador
              </label>
              <select
                className="form-control"
                value={prestador}
                onChange={(e) => setPrestador(e.target.value)}
                style={{ border: '1px solid #ced4da' }} // Estilo personalizado para o contorno
              >
                <option value="">Selecione um prestador</option>
                {prestadores.map((prestador) => (
                  <option
                    key={prestador.COD_PESSOA}
                    value={prestador.COD_PESSOA}
                  >
                    {prestador.PES_RAZAO}
                  </option>
                ))}
              </select>
            </Col>
          </Row>

          <div className="col-12 mb-4">
            <label
              htmlFor="InputNome"
              className="form-label"
            >
              Desconto em Dinheiro
            </label>

            <CustomPriceInput
              onChange={(e) => handleDescontoTotal(e.target.value)}
              value={desconto}
            />
          </div>

          <div>
            {/* Adicione um botão ou chave de alternância para trocar entre o modo de busca e entrada manual */}
            <button
              type="button"
              onClick={alternarModoBusca}
              className="botao-estilizado mb-3"
            >
              {/* Adicione o ícone do Bootstrap ao botão com o texto */}
              {estaBuscando ? (
                <>
                  <i className="bi bi-search"></i> Buscar
                </>
              ) : (
                <>
                  <i className="bi bi-pencil"></i> Inserção Manual
                </>
              )}
            </button>

            <div
              className="table-responsive overflow-auto"
              style={{ fontSize: '8px' }}
            >
              {loading ? (
                <div className="text-center">
                  <div
                    className="spinner-border"
                    role="status"
                  >
                    <span className="sr-only"></span>
                  </div>
                  <p>Carregando produtos...</p>
                </div>
              ) : (
                <div>
                  <div className="card shadow-sm border-0 mb-4">
                    <div className="card-header bg-black-50 text-muted d-flex justify-content-between align-items-center py-3">
                      <h5 className="mb-0 fw-bold">
                        <i className="bi bi-basket2-fill me-2"></i>
                        Produtos do Pedido
                      </h5>
                      <span className="badge bg-light text-primary fs-6">
                        {produtos.length} {produtos.length === 1 ? 'item' : 'itens'}
                      </span>
                    </div>

                    <div className="card-body p-0">
                      <div className="table-responsive">
                        <table className="table table-hover mb-0" style={{ fontSize: '11px' }}>
                          <thead className="table sticky-top">
                            <tr>
                              <th className="text-center fw-bold" style={{ minWidth: '120px' }}>
                                <i className="bi bi-upc-scan me-1"></i>
                                SKU / Ações
                              </th>
                              <th className="fw-bold" style={{ minWidth: '250px' }}>
                                <i className="bi bi-box-seam me-1"></i>
                                Produto
                              </th>
                              <th className="text-center fw-bold" style={{ width: '80px' }}>
                                <i className="bi bi-123 me-1"></i>
                                Qtd
                              </th>
                              {localStorage.admin === 'SIM' && (
                                <th className="text-end fw-bold" style={{ width: '100px' }}>
                                  <i className="bi bi-currency-dollar me-1"></i>
                                  Custo Unit.
                                </th>
                              )}
                              <th className="text-end fw-bold" style={{ width: '110px' }}>
                                <i className="bi bi-tag-fill me-1"></i>
                                Valor Unit.
                              </th>
                              <th className="text-end fw-bold" style={{ width: '90px' }}>
                                <i className="bi bi-percent me-1"></i>
                                Desconto
                              </th>
                              {localStorage.admin === 'SIM' && (
                                <th className="text-end fw-bold" style={{ width: '100px' }}>
                                  <i className="bi bi-calculator me-1"></i>
                                  Total Custo
                                </th>
                              )}
                              <th className="text-end fw-bold" style={{ width: '110px' }}>
                                <i className="bi bi-cash-coin me-1"></i>
                                Valor Total
                              </th>
                              <th className="fw-bold" style={{ width: '120px' }}>
                                <i className="bi bi-chat-square-text me-1"></i>
                                Observações
                              </th>
                              <th className="text-center fw-bold" style={{ width: '60px' }}>
                                <i className="bi bi-gear-fill"></i>
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {produtos.map((produto, index) => {
                              const isNewGroup = index === 0 ||
                                produto.grupo_item?.trim().toUpperCase() !==
                                produtos[index - 1]?.grupo_item?.trim().toUpperCase();

                              const isLastInGroup = index === produtos.length - 1 ||
                                produto.grupo_item?.trim().toUpperCase() !==
                                produtos[index + 1]?.grupo_item?.trim().toUpperCase();

                              return (
                                <React.Fragment key={produto.id}>
                                  {/* Header do Grupo */}
                                  {isNewGroup && produto.grupo_item && (
                                    <tr className="table-info">
                                      <td colSpan="11" className="py-3 px-4 border-start border-4 border-primary">
                                        <div className="d-flex justify-content-between align-items-center">
                                          <div className="d-flex align-items-center">
                                            <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                                              style={{ width: '32px', height: '32px' }}>
                                              <i className="bi bi-house-door-fill"></i>
                                            </div>
                                            <div>
                                              <h6 className="mb-0 text-primary fw-bold">
                                                {produto.grupo_item?.toUpperCase() || 'GRUPO SEM NOME'}
                                              </h6>
                                              <small className="text-muted">Ambiente do projeto</small>
                                            </div>
                                          </div>

                                          <div className="btn-group" role="group">
                                            <button
                                              type="button"
                                              onClick={() => moverGrupoParaCima(produto.grupo_item)}
                                              className="btn btn-outline-success btn-sm"
                                              disabled={index === 0}
                                              title="Mover grupo para cima"
                                            >
                                              <i className="bi bi-arrow-up"></i>
                                            </button>
                                            <button
                                              type="button"
                                              onClick={() => moverGrupoParaBaixo(produto.grupo_item)}
                                              className="btn btn-outline-primary btn-sm"
                                              disabled={isLastInGroup && index === produtos.length - 1}
                                              title="Mover grupo para baixo"
                                            >
                                              <i className="bi bi-arrow-down"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}

                                  {/* Linha do Produto */}
                                  <tr className={`${isLastInGroup ? 'border-bottom border-2 border-light' : ''}`}>
                                    {/* SKU e Imagem */}
                                    <td className="align-middle">
                                      <div className="d-flex align-items-center gap-2">
                                        <div className="position-relative">
                                          <img
                                            src={
                                              produto.image
                                                ? produto.image.includes('node.ziphub.com.br')
                                                  ? produto.image
                                                  : `${process.env.REACT_APP_BACKEND_API}/imagens/${produto.image}`
                                                : `${process.env.REACT_APP_BACKEND_API}/imagens/no-image.jpg`
                                            }
                                            className="rounded border shadow-sm"
                                            style={{
                                              width: '45px',
                                              height: '45px',
                                              objectFit: 'cover'
                                            }}
                                            alt="Produto"
                                          />
                                          <div className="position-absolute top-0 start-0 translate-middle">
                                            <button
                                              type="button"
                                              onClick={() => setItemSelecionado(index)}
                                              className="btn btn-primary btn-sm rounded-circle p-1"
                                              style={{ width: '24px', height: '24px' }}
                                              title="Editar grupo"
                                            >
                                              <i className="bi bi-pencil-fill" style={{ fontSize: '10px' }}></i>
                                            </button>
                                          </div>
                                        </div>

                                        <input
                                          type="text"
                                          value={produto.codigo}
                                          className="form-control form-control-sm border-0 bg-light"
                                          style={{ fontSize: '10px', width: '70px' }}
                                          placeholder="SKU"
                                          readOnly
                                        />
                                      </div>
                                    </td>

                                    {/* Descrição do Produto */}
                                    <td className="align-middle">
                                      <div className="w-100">
                                        {estaBuscando ? (
                                          <AutocompleteProdutoMatch
                                            placeholder="🔍 Buscar na base de dados..."
                                            onClickId={(id) => handleProdutoIdChange(id, index)}
                                            onClickNome={(nome) => handleProdutoNomeChange(nome, index)}
                                            onClickProdInterno={(prodInterno) => handleProdutoInternoChange(prodInterno, index)}
                                            OnClickValor={(vlr) => handleVlUnitChange(vlr, index)}
                                            OnClickCusto={(custo) => handleCusto(custo, index)}
                                            OnClickImg={(img) => handleImg(img, index)}
                                            ClickTexto={handleTextoChange}
                                            value={produto.descricao}
                                            className="form-control form-control-sm"
                                          />
                                        ) : (
                                          <input
                                            type="text"
                                            placeholder="✏️ Inserir manualmente..."
                                            className="form-control form-control-sm"
                                            value={produto.descricao}
                                            onChange={(e) => handleProdutoNomeChangeInput(e.target.value, index)}
                                            style={{ fontSize: '11px' }}
                                          />
                                        )}
                                      </div>
                                    </td>

                                    {/* Quantidade */}
                                    <td className="align-middle">
                                      <div className="input-group input-group-sm">
                                        <input
                                          type="text"
                                          onChange={(e) => handleQtdChange(e.target.value.replace(',', '.'), index)}
                                          value={produto?.quantidade !== undefined ? produto?.quantidade.toString() : ''}
                                          className="form-control text-center fw-bold"
                                          style={{ fontSize: '11px' }}
                                        />
                                        <span className="input-group-text bg-light text-muted" style={{ fontSize: '9px' }}>
                                          un
                                        </span>
                                      </div>
                                    </td>

                                    {/* Custo Unitário (Admin) */}
                                    {localStorage.admin === 'SIM' && (
                                      <td className="align-middle">
                                        <div className="input-group input-group-sm">
                                          <span className="input-group-text bg-light text-muted" style={{ fontSize: '9px' }}>
                                            R$
                                          </span>
                                          <input
                                            type="text"
                                            onChange={(e) => handleCusto(e.target.value.replace(',', '.'), index)}
                                            value={
                                              produto.preco_custo !== undefined
                                                ? produto.preco_custo?.toLocaleString(undefined, { minimumFractionDigits: 2 })
                                                : ''
                                            }
                                            className="form-control text-end"
                                            style={{ fontSize: '10px' }}
                                          />
                                        </div>
                                      </td>
                                    )}

                                    {/* Valor Unitário */}
                                    <td className="align-middle">
                                      <div className="input-group input-group-sm">
                                        <span className="input-group-text bg-primary text-white" style={{ fontSize: '9px' }}>
                                          R$
                                        </span>
                                        <input
                                          type="text"
                                          onChange={(e) => handleVlUnitChange(e.target.value.replace(',', '.'), index)}
                                          value={
                                            produto.valorunitario !== undefined
                                              ? produto.valorunitario.toLocaleString(undefined, { minimumFractionDigits: 2 })
                                              : ''
                                          }
                                          className="form-control text-end fw-bold"
                                          style={{ fontSize: '10px' }}
                                        />
                                      </div>
                                    </td>

                                    {/* Desconto */}
                                    <td className="align-middle">
                                      <div className="input-group input-group-sm">
                                        <CustomPriceInput
                                          value={produto.desconto}
                                          onChange={(e) => handleDescontoChange(e.target.value.replace(',', '.'), index)}
                                          style={{ fontSize: 10 }}
                                          className="form-control text-end"
                                        />
                                        <span className="input-group-text bg-warning text-dark" style={{ fontSize: '9px' }}>
                                          %
                                        </span>
                                      </div>
                                    </td>

                                    {/* Total Custo (Admin) */}
                                    {localStorage.admin === 'SIM' && (
                                      <td className="align-middle">
                                        <div className="input-group input-group-sm">
                                          <span className="input-group-text bg-light text-muted" style={{ fontSize: '9px' }}>
                                            R$
                                          </span>
                                          <input
                                            type="text"
                                            value={
                                              produto.total_custo !== undefined
                                                ? produto.total_custo?.toLocaleString(undefined, { minimumFractionDigits: 2 })
                                                : ''
                                            }
                                            className="form-control text-end bg-light"
                                            disabled
                                            style={{ fontSize: '10px' }}
                                          />
                                        </div>
                                      </td>
                                    )}

                                    {/* Valor Total */}
                                    <td className="align-middle">
                                      <div className="input-group input-group-sm">
                                        <span className="input-group-text bg-success text-white" style={{ fontSize: '9px' }}>
                                          R$
                                        </span>
                                        <CustomPriceInput
                                          disabled
                                          value={produto.valor_total_item}
                                          style={{ fontSize: '10px' }}
                                          className="form-control text-end fw-bold bg-light"
                                        />
                                      </div>
                                    </td>

                                    {/* Observações */}
                                    <td className="align-middle">
                                      <textarea
                                        value={produto.obs}
                                        className="form-control form-control-sm"
                                        onChange={(e) => handleObsChange(e.target.value, index)}
                                        style={{ fontSize: '10px', minHeight: '38px', resize: 'vertical' }}
                                        placeholder="Observações..."
                                        rows="2"
                                      />
                                    </td>

                                    {/* Ações */}
                                    <td className="align-middle text-center">
                                      <div className="btn-group-vertical" role="group">
                                        <OverlayTrigger overlay={<Tooltip>Excluir Item</Tooltip>}>
                                          <CustomButton
                                            type="button"
                                            isLoading={isDeleteProductLoading[index]}
                                            color="#dc3545"
                                            onClick={() => ExcluirProduto(produto, index)}
                                            className="btn btn-outline-danger btn-sm"
                                            style={{ fontSize: '10px', padding: '4px 8px' }}
                                          >
                                            <i className="bi bi-trash3-fill"></i>
                                          </CustomButton>
                                        </OverlayTrigger>
                                      </div>
                                    </td>
                                  </tr>

                                  {/* Linha de Subtotal do Grupo */}
                                  {isLastInGroup && produto.grupo_item && (
                                    <tr className="table-light">
                                      <td colSpan={localStorage.admin === 'SIM' ? '9' : '7'} className="text-end fw-bold text-primary">
                                        Subtotal {produto.grupo_item?.toUpperCase()}:
                                      </td>
                                      <td className="text-end fw-bold text-success">
                                        <div className="badge bg-success fs-6">
                                          {produtos
                                            .filter(p => p.grupo_item === produto.grupo_item)
                                            .reduce((total, p) => total + (p.valor_total_item || 0), 0)
                                            .toLocaleString('pt-BR', {
                                              style: 'currency',
                                              currency: 'BRL'
                                            })
                                          }
                                        </div>
                                      </td>
                                      <td></td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              );
                            })}
                          </tbody>

                          {/* Footer com Totais */}
                          <tfoot className="table">
                            <tr>
                              <th colSpan={localStorage.admin === 'SIM' ? '7' : '5'} className="text-end fw-bold">
                                <i className="bi bi-calculator me-2"></i>
                                TOTAL GERAL:
                              </th>
                              {localStorage.admin === 'SIM' && (
                                <th className="text-end text-warning">
                                  {produtos
                                    .reduce((total, p) => total + (p.total_custo || 0), 0)
                                    .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                                  }
                                </th>
                              )}
                              <th className="text-end text-success fs-5">
                                {produtos
                                  .reduce((total, p) => total + (p.valor_total_item || 0), 0)
                                  .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                                }
                              </th>
                              <th colSpan="2"></th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>

                    {/* Card Footer com Resumo */}
                    <div className="card-footer bg-light">
                      <div className="row text-center">
                        <div className="col-md-3">
                          <div className="d-flex flex-column">
                            <span className="text-muted small">Total de Itens</span>
                            <span className="fw-bold text-primary fs-5">{produtos.length}</span>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="d-flex flex-column">
                            <span className="text-muted small">Qtd Total</span>
                            <span className="fw-bold text-info fs-5">
                              {produtos
                                .reduce((total, p) => total + Number(p.quantidade || 0), 0)
                                .toFixed(2)}


                            </span>
                          </div>
                        </div>
                        {localStorage.admin === 'SIM' && (
                          <div className="col-md-3">
                            <div className="d-flex flex-column">
                              <span className="text-muted small">Margem Estimada</span>
                              <span className="fw-bold text-warning fs-5">
                                {(() => {
                                  const totalVendas = produtos.reduce(
                                    (total, p) => total + Number(p.valor_total_item || 0),
                                    0
                                  );
                                  const totalCustos = produtos.reduce(
                                    (total, p) => total + Number(p.total_custo || 0),
                                    0
                                  );

                                  // Evita divisão por zero
                                  if (totalVendas === 0) return "0.0%";

                                  const margem = ((totalVendas - totalCustos) / totalVendas) * 100;
                                  return `${margem.toFixed(1)}%`;
                                })()}
                              </span>

                            </div>
                          </div>
                        )}
                        <div className="col-md-3">
                          <div className="d-flex flex-column">
                            <span className="text-muted small">Valor Total</span>
                            <span className="fw-bold text-success fs-4">
                              {produtos
                                .reduce((total, p) => total + (p.valor_total_item || 0), 0)
                                .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                              }
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {produtos.length === 0 && (
                    <div className="no-item">
                      <p style={{ fontSize: 20 }}>Nenhum produto cadastrado</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="col-md-6">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={AdicionarProduto}
            >
              Adicionar Produto
            </button>
          </div>
          <div className="col-md-6 text-end mb-5">
            {localStorage.admin === 'SIM' && (
              <div>
                <span className="me-4">Total Custo:</span>
                <b>
                  {new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  }).format(totalCusto)}
                </b>
              </div>
            )}
            <div>
              <span className="me-4">Total Pedido:</span>
              <b>
                {new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }).format(vl_total)}
              </b>
            </div>
          </div>

          <div className="col-12">
            <label
              htmlFor="InputNome"
              className="form-label"
            >
              Observações
            </label>
            <textarea
              type="text"
              onChange={(e) => setDetalhesPedido(e.target.value)}
              value={detalhesPedido}
              className="form-control"
            ></textarea>
          </div>

          <div className="col-12 mt-3">
            {msg.length > 0 && (
              <div className="alert alert-danger mt-4 text-center">{msg}</div>
            )}

            <div className="d-flex justify-content-end">
              <Link
                to="/orcamentos"
                type="button"
                className="btn btn-outline-primary me-4"
              >
                Cancelar
              </Link>

              <button
                type="button"
                className="btn btn-success me-4"
                onClick={SalvarDados}
                disabled={loading}
              >
                {loading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : (
                  'Salvar Dados'
                )}
              </button>

              <button
                type="button"
                className="btn btn-danger me-4"
                onClick={() => ImpPdf('Completo')}
              >
                <i className="bi bi-file-pdf"></i> Imprimir PDF
              </button>

              <button
                type="button"
                className="btn btn-danger"
                onClick={() => ImpPdf('Resumo')}
              >
                <i className="bi bi-file-pdf"></i> Imp. espelho
              </button>

              <CustomButton
                title="Transformar em Pedido"
                color="#7445e1"
                onClick={() => handleExportSale(id_pedido)}
                isLoading={isExportSaleLoading}
              >
                <ShareFill />
              </CustomButton>
            </div>
          </div>
        </div>

        <Modal
          show={itemSelecionado !== null}
          onHide={() => setItemSelecionado(null)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Informações do Grupo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {itemSelecionado !== null && (
              <div className="row mb-3">
                {/* <div className="col-4">
                  <p>Sequencial: {produtos[itemSelecionado].seq_item}</p>
                  <Form.Control
                    type="text"
                    value={inputSeq} // Corrigido para o valor do sequencial
                    onChange={handleSeqChange} // Corrigido para a função do sequencial
                    placeholder="seq..."
                  />
                </div> */}
                <div className="col-8">
                  <p>Grupo: {produtos[itemSelecionado].grupo_item}</p>
                  <Form.Control
                    type="text"
                    value={inputValue} // Corrigido para o valor do grupo
                    onChange={handleInputChange} // Corrigido para a função do grupo
                    placeholder="grupo..."
                  />
                </div>
              </div>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              onClick={handleInserir}
              variant="primary"
            >
              Inserir
            </Button>
          </Modal.Footer>
        </Modal>

        {showModal && (
          <ModalIncluirCliente
            onSaveCliente={handleSaveCliente}
            onCancel={() => setShowModal(false)}
          />
        )}
      </div>
    </>
  )
}

export default OrcamentoEditar
